import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=31e7cb00&scoped=true"
import script from "./personalCard.vue?vue&type=script&lang=js"
export * from "./personalCard.vue?vue&type=script&lang=js"
import style0 from "./personalCard.vue?vue&type=style&index=0&id=31e7cb00&prod&scoped=true&lang=scss"
import style1 from "./personalCard.vue?vue&type=style&index=1&id=31e7cb00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7cb00",
  null
  
)

export default component.exports